export default __webpack_public_path__ + "static/media/add-comment-icon-blue.83440996.svg";